(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-community-slider"] && !Shopify.designMode) return;
  try {
    
// Select all icon elements and all video elements
var icons = document.querySelectorAll('.swiper-slide .icon_container');
var videos = document.querySelectorAll('.videoWrapper video');

// Add an event listener to each icon
icons.forEach((icon, index) => {
    icon.addEventListener('click', function() {
        // Get the corresponding video element
        var video = videos[index];
        var svg = icon.querySelector('svg');

        if (svg) {
            if (video.paused) {
                video.play();
                svg.style.display = 'none'; // Hide the SVG icon
            } else {
                video.pause();
                svg.style.display = 'block'; // Show the SVG icon
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-two-col-faq"] && !Shopify.designMode) return;
  try {
    

var accordionTitles = document.querySelectorAll(".faq-list__item");
      accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("is-open")) {
        accordionTitle.classList.remove("is-open");
      } else {
      var accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
      accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
        accordionTitleWithIsOpen.classList.remove("is-open");
      });
      accordionTitle.classList.add("is-open");
    }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  addEventListener("load", (event) => {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            const prductRecommendationSwiper = new Swiper(document.querySelector('.products-recommendations-slider__products'), {
              slidesPerView: 1.27,
              slidesPerView: 1.27,
              spaceBetween: 20,
              cssMode: true,
              centeredSlides: true,
              loop: false,
              centeredSlidesBounds: true,
              navigation: {
                nextEl: '[js-products-slider="next"]',
                prevEl: '[js-products-slider="prev"]',
              },
              breakpoints: {
                767: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 2,
                },
                1000: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 3,
                },
                1100: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                1500: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 30
                }
              }
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

    observer.observe(productRecommendationsSection);
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-suggestions"] && !Shopify.designMode) return;
  try {
    
      addEventListener("load", (event) => {
          
          const productSuggestionsSlider = new Swiper(document.querySelector('.products-suggestions-slider__products'), {
              slidesPerView: 1.27,
              spaceBetween: 20,
              cssMode: true,
              centeredSlides: true,
              loop: false,
              centeredSlidesBounds: true,
              navigation: {
                  nextEl: '[js-products-suggestion-slider="next"]',
                  prevEl: '[js-products-suggestion-slider="prev"]',
              },
              breakpoints: {
                  767: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 2,
                  },
                  1000: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  slidesPerView: 3,
                  },
                  1100: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 3,
                  spaceBetween: 30
                  },
                  1500: {
                  centeredSlides: false,
                  centeredSlidesBounds: false,
                  cssMode: false,
                  slidesPerView: 4,
                  spaceBetween: 30
                  }
              }
          });
          
      });
  
  } catch(e) { console.error(e); }
})();
})();
